<template>
  
  <el-menu
    :collapse="menuIsCollapse"
  >
    <MenuItme 
      v-for="(menu, index) in menuList"
      :key="menu"
      :data="menu"
      :defaultIndex="index+1"
    />
  </el-menu>
</template>

<script setup>
import { 
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick
} from 'vue';
import store from '@/store';

import { isNull, dayjs, message } from '@/utils/js/initVariable';

import MenuItme from './component/MenuItem.vue';

// props
const props = defineProps({
  
});
// emit
const emit = defineEmits([
  
]);
const menuIsCollapse = computed(()=>{
  return store.getters['permissions/getMenuIsCollapse'];
});
const menuList = computed(()=>{
  return store.getters['permissions/getMenuList'];
});

// 组件挂载前
onBeforeMount(()=>{

});
// 组件挂载后
onMounted(()=>{

});
// 组件更新后
onUpdated(()=>{

});
// 组件销毁后
onUnmounted(()=>{

});
</script>

<style lang='less'>
.el-menu{
  border-right: none;
}
.el-menu-item.is-active{
  background-color: var(--el-menu-hover-bg-color); 
}
</style>

<style lang='less' scoped>
</style>